export function Logo({ light = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src="/exon-emblem.png" alt="Exon Global emblem" width="70" height="44"
        className="h-12 lg:h-14 w-auto object-contain shrink-0" />
      <span className={`font-head font-extrabold tracked text-2xl lg:text-[26px] leading-none ${light ? "text-white" : "text-[#0A192F]"}`}>
        EXON<span className="gold-text"> GLOBAL</span>
      </span>
    </div>
  );
}
